import { DynamicInputModel, serializable, DynamicFormControlLayout, DynamicInputModelConfig } from '@ng-dynamic-forms/core';
import { PageBuilderItem, PAGE_BUILDER_CODE_COMPONENT } from '../page-builder-components.models';

export interface PageBuilderTextareaModelConfig extends DynamicInputModelConfig {
}

export class PageBuilderTextareaModel extends DynamicInputModel {
	@serializable() readonly type: string = 'page_builder_textarea'; 

	constructor(config: PageBuilderTextareaModelConfig, layout?: DynamicFormControlLayout) {
		super(config, layout);
	}

	static initModel(_component: PageBuilderItem): PageBuilderTextareaModel { 
		const formModel = new PageBuilderTextareaModel({
			id: _component.ID,
			name: _component.ID,
			label: _component.LABEL,
			value: _component.DEFAULT_VALUE,
			required: _component.IS_REQUIRED,
			readOnly: _component.IS_READONLY,
			hidden: _component.IS_VISIBLE
		});
		return formModel;
	}

	static getProperties() {
        return {
            CODE: PAGE_BUILDER_CODE_COMPONENT.TEXTAREA,
            NAME: 'Textarea',
            ICON: 'text_fields',
            PROPERTIES: [
                { ID: 'TYPE_COMPONENT', CODE: PAGE_BUILDER_CODE_COMPONENT.TEXTBOX, LABEL: 'Type', DEFAULT_VALUE: 'Textarea', IS_READONLY: true },
                { ID: 'INDEX', CODE: PAGE_BUILDER_CODE_COMPONENT.NUMERIC_TEXTBOX, LABEL: 'Index' },
            ]
        };
    }
}